"use strict";
const _ = require('lodash');
const { VINDEN_ORDER_FULLFILLMENT_CENTER_ID, EXACTA_ORDER_FULLFILLMENT_CENTER_ID, } = require('../orderFullfillmentCenter');
const { calculateRequiresAlcoholPermit } = require('../article');
const ensureQuantitiesAndParcels = row => {
    if (!row.article)
        return row;
    const ensuredRow = { ...row };
    const { orderedParcels, orderedQuantity, receivedParcels, receivedQuantity, article, } = row;
    if (orderedParcels > 0 && !_.isNumber(orderedQuantity)) {
        ensuredRow.orderedQuantity = orderedParcels * (article.colliSize || 1);
    }
    if (orderedQuantity > 0 && !_.isNumber(orderedParcels)) {
        ensuredRow.orderedParcels = orderedQuantity / (article.colliSize || 1);
    }
    if (receivedParcels > 0 && !_.isNumber(receivedQuantity)) {
        ensuredRow.receivedQuantity = receivedParcels * (article.colliSize || 1);
    }
    if (receivedQuantity > 0 && !_.isNumber(receivedParcels)) {
        ensuredRow.receivedParcels = receivedQuantity / (article.colliSize || 1);
    }
    return ensuredRow;
};
const getOrderFullfillmentCenterForTargetWarehouse = targetWarehouse => {
    if (targetWarehouse === 'exacta')
        return { name: 'Exacta', id: EXACTA_ORDER_FULLFILLMENT_CENTER_ID };
    return { name: 'Vinden', id: VINDEN_ORDER_FULLFILLMENT_CENTER_ID };
};
const requiresEMCS = purchaseOrder => {
    if (_.get(purchaseOrder, 'purchaseOrderRows.length', 0) === 0) {
        return false;
    }
    return !!purchaseOrder.purchaseOrderRows.find(x => calculateRequiresAlcoholPermit(_.get(x, 'article.productCategory'), _.get(x, 'article.alcoholPercentage')));
};
module.exports = entity => {
    const rows = [];
    let owningSupplierOrganizationId = entity.owningSupplierOrganizationId;
    if (entity.purchaseOrderRows) {
        for (let i = 0; i < entity.purchaseOrderRows.length; i++) {
            let row = entity.purchaseOrderRows[i];
            if (!row.price) {
                row.price = _.get(row, 'article.purchasePrice');
            }
            row = ensureQuantitiesAndParcels(row);
            rows.push(row);
            if (!owningSupplierOrganizationId && row.article) {
                owningSupplierOrganizationId = row.article.owningSupplierOrganizationId;
            }
        }
    }
    return {
        ...entity,
        owningSupplierOrganizationId,
        orderFullfillmentCenter: getOrderFullfillmentCenterForTargetWarehouse(entity.targetWarehouse),
        purchaseOrderRows: rows,
        requiresEMCS: requiresEMCS(entity),
    };
};
